import styled from "styled-components";
import { TextColorNames } from "@smartsuite/types";

export const Root = styled.div`
  color: ${TextColorNames.primary};
  white-space: nowrap;
  opacity: 0.6;
`;

export const Event = styled.span`
  font-weight: 600;
  font-size: 12px;
  line-height: 18px;
`;

export const Text = styled.span`
  font-weight: 400;
  font-size: 13px;
  line-height: 18px;

  .author {
    text-decoration: underline;
  }
  .date {
    font-weight: 600;
  }
`;
